var _defs, _path, _polygon, _polygon2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobseekerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 496.2 496.2",
    viewBox: "0 0 496.2 496.2",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f38526",
    d: "M248.1,0C111.1,0,0,111.1,0,248.1s111.1,248.1,248.1,248.1s248.1-111.1,248.1-248.1S385.1,0,248.1,0z ",
    className: "colorea4949 svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#baab27",
    points: "376.3 345.2 372.2 345.2 372.2 354 378 354",
    className: "colorbaab27 svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#baab27",
    points: "119.9 345.1 118.1 354 123.9 354 123.9 345.2",
    className: "colorbaab27 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M418.5,382.8c-8.5-27.3-81.2-49.3-170.8-49.3s-161.5,22-170,49.3c-2.6,8.5-5.5,22.2-8.3,37.4 c45.1,46.9,108.5,76,178.7,76s133.6-29.2,178.7-76C424.1,405,421.2,391.2,418.5,382.8z",
    className: "color334d5c svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a379",
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3l26.9,6.1h22l26.9-6.1C286,335.4,274.9,318.7,287,282.1z",
    className: "colore2a379 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a379",
    d: "M247.9,317l-37.7,18.4c0,0,16.8,28.1,37.6,28.1s38.2-28.1,38.2-28.1L247.9,317z",
    className: "colore2a379 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a379",
    d: "M247.8,322.9c-28.2,0-37.4,12.4-37.4,12.4s9.7,51.8,37.7,51.8s37.8-51.8,37.8-51.8 S275.9,322.9,247.8,322.9z",
    className: "colore2a379 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3c624",
    d: "M301,333.1c0,0-39.9,136-52.9,136S195.2,333,195.2,333c-29.5,3.1-55.4,4.8-75.3,12.1l41.2,135.4 c23.9,9,49.6,14.3,76.3,15.4c3.5,0.1,7.1,0.2,10.7,0.2c3.6,0,7.1-0.1,10.7-0.2c26.8-1.1,52.4-6.5,76.3-15.4l41.2-135.3 C356.3,338,330.4,336.2,301,333.1z",
    className: "colord3c624 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3c624",
    d: "M187.3 488.6c4.3 1.1 8.6 2 12.9 2.9C195.8 490.7 191.5 489.7 187.3 488.6zM296.1 491.5c4.3-.8 8.6-1.8 12.9-2.9C304.7 489.7 300.4 490.7 296.1 491.5z",
    className: "colord3c624 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d6d6",
    d: "M200.5 491.6c-.1 0-.2 0-.3-.1C200.3 491.5 200.4 491.6 200.5 491.6L200.5 491.6zM165.8 336c-8.2.9-15.9 1.9-23.2 3.2l31.6 145.7c4.3 1.3 8.6 2.5 12.9 3.6h.1c4.3 1.1 8.6 2 12.9 2.9.1 0 .2 0 .3.1L165.8 336zM295.7 491.6L295.7 491.6c.1 0 .2 0 .3-.1L295.7 491.6z",
    className: "colord6d6d6 svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d6d6",
    d: "M329.6,336.1c-6.8,31-33.8,155.1-33.9,155.5c0.1,0,0.2,0,0.3-0.1c4.3-0.8,8.6-1.8,12.9-2.9 c0.1,0,0.1,0,0.2,0c2.1-0.5,4.3-1.1,6.4-1.7l0,0c2.2-0.6,4.3-1.2,6.5-1.9l30.8-145.7C345.5,338,337.7,337,329.6,336.1z",
    className: "colord6d6d6 svgShape"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4b382",
    d: "M248.1,61.6c-48.7,0-88.3,21.2-88.3,113.6c0,31.3,6.2,55.8,15.5,74.7c20.4,41.6,55.7,56.1,72.8,56.1 s52.4-14.5,72.8-56.1c9.3-18.9,15.5-43.4,15.5-74.7C336.4,82.8,296.8,61.6,248.1,61.6z",
    className: "colorf4b382 svgShape"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4b382",
    d: "M161.4 178c-8.4 1.4-14.9 5.1-10.1 32.9s10.7 29.1 19.1 27.7L161.4 178zM334.9 178l-9 60.6c8.4 1.4 14.3.1 19.1-27.7C349.7 183.1 343.3 179.5 334.9 178z",
    className: "colorf4b382 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M248.1,273.3c-3.9,0-6.5,3.4-6.5,3.4c0,1.9,2.9,10.2,6.5,10.2s6.5-8.3,6.5-10.2 C254.6,276.7,252,273.3,248.1,273.3z",
    className: "color30302e svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5a173",
    d: "M259.3,255.1c-3.2-0.5-11.2,2.6-11.2,2.6s-8.1-3-11.3-2.6c-5.2,0.7-12.8,4.8-12.8,6.2 c0,2.3,10.8,8.5,24.2,8.5c13.4,0,24.2-6.3,24.2-8.5C272.3,261.3,264.5,255.8,259.3,255.1z",
    className: "colore5a173 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d89364",
    d: "M248.1,262.4c-14.3,0-24.2-1.1-24.2-1.1c0,2.3,10.8,11.1,24.2,11.1s24.2-8.8,24.2-11.1 C272.3,261.3,262.4,262.4,248.1,262.4z",
    className: "colord89364 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M248.1,59.1c-58,0-88.3,23.7-88.3,116.1l38.8-68.4c0,0,27.5,4.3,49.5,4.3s46.2-4.3,46.2-4.3 l42.1,68.4C336.4,82.8,306.1,59.1,248.1,59.1z",
    className: "color30302e svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M180.1 138.6l-14.6 2.2c-4.2 10.9-5.6 24.4-5.6 37.5 0 0 8.8-1.9 8.8 2.6l2.8 43.1 3.9-1.9C175 199.1 180.1 138.6 180.1 138.6zM330.8 140.8l-14.6-.4c0 0 5.1 58.7 4.9 81.7l3.9 1.9 2.8-43.1c0-4.5 8.8-2.6 8.8-2.6C336.5 165.1 335.1 151.7 330.8 140.8z",
    className: "color30302e svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M311.5,337.4L311.5,337.4L311.5,337.4L311.5,337.4z",
    className: "colorfff svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5aa17",
    d: "M324.1,76.5c-13.5-20-50.5-37.3-75.8-37.3s-62.5,17.3-76,37.3c-12.6,18.6-15.9,71.4-11.2,71.4h174.2 C338.4,147.9,336.7,95.1,324.1,76.5z",
    className: "colore5aa17 svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc76c",
    d: "M159.2,141.5l0.9,21c0,0,37.9,3.9,88,3.9s87.9-3.9,87.9-3.9l0.2-21H159.2z",
    className: "colorefc76c svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5aa17",
    d: "M248.1,35.8c-17,0-30.7,3.4-30.7,10.5V69c0,7.1,13.7,86.9,30.7,86.9c16.9,0,30.7-79.8,30.7-86.9V46.3 C278.8,39.3,265,35.8,248.1,35.8z",
    className: "colore5aa17 svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#c18d17",
    d: "M217.5 46.3L217.5 46.3c-.1-.1-.2-.1-.2 0l0 0c-.8 1.9-1.1 3.8-1.4 5.7-.2.9-.2 1.9-.3 2.8-.1.9-.1 1.9-.1 2.8s0 1.9.1 2.8.1 1.9.3 2.8c.3 1.9.7 3.8 1.4 5.7l0 0 .1.1c.1 0 .1 0 .1-.1l.1-11.3L217.5 46.3zM280.6 54.8c-.1-.9-.1-1.9-.3-2.8-.3-1.9-.7-3.8-1.4-5.7l0 0-.1-.1c-.1 0-.1 0-.1.1l-.1 11.3.1 11.3c0 0 0 .1.1.1s.1 0 .1-.1l0 0c.8-1.9 1.1-3.8 1.4-5.7.2-.9.2-1.9.3-2.8.1-.9.1-1.9.1-2.8S280.7 55.8 280.6 54.8z",
    className: "colorc18d17 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4b21e",
    d: "M266.3,42.8c0-7.1-8.1-12.8-18.2-12.8s-18.2,5.8-18.2,12.8l-12.1,96.7c0,7.1,20.3,12.8,30.3,12.8 s30.3-5.8,30.3-12.8L266.3,42.8z",
    className: "colorf4b21e svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5aa17",
    d: "M332.5,129.2c-12.6-0.5-48.6,7.5-84.4,7.5c-35.3,0-70.4-8-82.6-7.5c-12.1,0-16.1,23.6-16.1,23.6 s42.5,4.3,98.8,4.3s98.6-4.3,98.6-4.3S343,129.2,332.5,129.2z",
    className: "colore5aa17 svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#c18d17",
    d: "M313.8,133.4c-7.4,0.5-14.7,0.9-22.1,1.2c-14.7,0.6-29.5,1.1-44.2,1c-14.7,0.1-29.5-0.4-44.2-1 c-7.4-0.3-14.7-0.7-22.1-1.2c-7.4-0.4-14.7-1-22.1-1.5c7.3,1,14.6,1.8,22,2.6c7.3,0.7,14.7,1.3,22.1,1.8c14.7,1,29.5,1.4,44.3,1.5 c14.8-0.1,29.5-0.5,44.3-1.5c7.4-0.5,14.7-1.1,22.1-1.8c7.3-0.8,14.7-1.5,22-2.6C328.5,132.4,321.2,133,313.8,133.4z",
    className: "colorc18d17 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobseekerIcon);
export default __webpack_public_path__ + "static/media/jobseekerIcon.eee803ddd51da977175df93d550f70af.svg";
export { ForwardRef as ReactComponent };